import React from 'react';
import Button from '../Buttons/Button';
import { customGaEvent, GA_EVENTS } from '../../utils/ga';
import FacebookIconSvg from '../SvgComponents/FacebookLogoSvg';
import XIconSvg from '../SvgComponents/XLogoSvg';
import LinkedinIconSvg from '../SvgComponents/LinkedinLogoSvg';

const SocialShareButton = ({ type, href }) => {
  const onClick = () => {
    window.open(
      href,
      'targetWindow',
      'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=250'
    );
    customGaEvent({
      action: GA_EVENTS.SHARE_TOUR,
      label: type,
    });
    return false;
  };

  const renderShareIcon = () => {
    switch (type) {
      case 'facebook': {
        return <FacebookIconSvg fill={'#4a4a4a'} />;
      }
      case 'X': {
        return <XIconSvg />;
      }
      case 'linkedin': {
        return <LinkedinIconSvg fill={'#4a4a4a'} />;
      }
      default: {
        return null;
      }
    }
  };

  return (
    <Button
      handleClick={onClick}
      className="socialshare-button"
      aria-label={`Share on ${type}`}
    >
      {renderShareIcon()}
    </Button>
  );
};

export default SocialShareButton;
